import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { SimpleIconsGimpComponent } from './simple-icons-gimp.component';
 @NgModule({
    imports:      [ BrowserModule ],
    providers:    [],
    declarations: [ SimpleIconsGimpComponent ],
    exports:      [ SimpleIconsGimpComponent ],
    bootstrap:    []
})
export class SimpleIconsGimpModule {}
